import React from 'react'
import FooterApi from 'utils/FooterApi'
import BreadcrumbComponent from 'components/Breadcrumbs'
import { MainWrapper, AboutUsWrapper, ContentWrapper } from 'styles/FooterLinks/AboutUsPage'

const TermsAndConditions = () => {
  const { data } = FooterApi('tandc')
  return (
    <MainWrapper>
      <AboutUsWrapper>
        <BreadcrumbComponent title="Terms & Condition" />
        <ContentWrapper>
          <div dangerouslySetInnerHTML={{ __html: data?.tandc }} />
        </ContentWrapper>
      </AboutUsWrapper>
    </MainWrapper>
  )
}

export default TermsAndConditions
